import React, {ReactElement} from "react";

function Spacer(): ReactElement {
    return (
        <div style={{flexGrow: "1"}}/>
    );
}

export default Spacer;
